import {SortOrder} from '../constants';

export type GetSortOrderParams = {
	sortOrder?: string | null;
	defaultSortOrder?: SortOrder;
};

/** will return the passed in sort order if valid, otherwise will return the default sort order */
export const getSortOrder = ({
	sortOrder,
	defaultSortOrder,
}: GetSortOrderParams): SortOrder =>
	Object.values(SortOrder).includes(sortOrder as SortOrder)
		? (sortOrder as SortOrder)
		: defaultSortOrder || SortOrder.DESCENDING;

export default getSortOrder;
